exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dummy-username-password{display:flex;justify-content:space-between}.dummy-username-password .dummy-input{display:flex;flex-direction:column;width:48%}", ""]);

// exports
